import { tryParseJson } from '@jbhi-fi/utils/src/JSON/tryParseJson';
import resolveResponse from 'contentful-resolve-response';
import { strFromU8, inflateSync } from 'fflate';

interface CompressedContentfulData {
  compressed: string;
}

const decompressContentfulData = () => {
  const shouldUseCachedGenericPages = window?.Jbhifi?.contentfulSettings?.shouldUseCachedGenericPages ?? true;
  if (!shouldUseCachedGenericPages) return;

  const compressedString = window.Jbhifi?.contentfulCompressedString;

  if (!compressedString) {
    return;
  }

  try {
    const compressedData = tryParseJson<CompressedContentfulData>(decodeURIComponent(compressedString));
    const base64 = compressedData?.compressed;

    if (!base64) {
      return;
    }

    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const decompressedBytes = inflateSync(bytes);

    const jsonString = strFromU8(decompressedBytes);
    const parsedData = JSON.parse(jsonString);

    const resolvedData = resolveResponse(parsedData);

    window.Jbhifi.decompressedContentfulData = resolvedData[0];
  } catch (err) {
    console.error('Contentful: Decompression Error:', err);
  }
};

const parseContentfulDataString = () => {
  const contentfulDataString = window.Jbhifi?.contentfulDataString;
  if (!contentfulDataString) {
    return;
  }
  const parsedData = tryParseJson(decodeURIComponent(contentfulDataString));
  if (!parsedData) {
    console.error('Contentful: Invalid contentful data string format');
    return;
  }
  window.Jbhifi.contentfulData = parsedData;
};

decompressContentfulData();
parseContentfulDataString();
